import {Routes} from '@angular/router';
import {CommissionPopupComponent} from './commission-dialog.component';


export const commissionRoute: Routes = [
];

export const commissionPopupRoute: Routes = [
  {
    path: 'commission-new/:campagneId',
    component: CommissionPopupComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
        pageTitle: 'cadensApp.commission.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'commission-new/:campagneId/:id',
    component: CommissionPopupComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
        pageTitle: 'cadensApp.commission.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/commission/commission.route.ts